import { render, staticRenderFns } from "./EntryText.vue?vue&type=template&id=5665fc96&scoped=true"
import script from "./EntryText.vue?vue&type=script&lang=js"
export * from "./EntryText.vue?vue&type=script&lang=js"
import style0 from "./EntryText.vue?vue&type=style&index=0&id=5665fc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665fc96",
  null
  
)

export default component.exports